
import React from "react";
import { Dumbbell } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { advancedTierSchema } from "@/contexts/program-creation/types";

interface CurrentTrainingSectionProps {
  form: UseFormReturn<z.infer<typeof advancedTierSchema>>;
}

export default function CurrentTrainingSection({ form }: CurrentTrainingSectionProps) {
  return (
    <div className="space-y-5 mb-8">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <Dumbbell size={18} />
        <h4 className="font-medium">Current Training</h4>
      </div>
      
      <FormField
        control={form.control}
        name="currentProgramDetails"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              What does their current training program look like? Include training split, volume, etc.
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Upper/Lower split, 5 days/week with heavy compound movements and accessory work focused on hypertrophy" 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="trainingPhilosophy"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              Do they follow a specific training philosophy or system?
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Powerlifting, 5/3/1, StrongLifts, conjugate method, progressive overload, block periodization" 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
